import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { type Board } from '@air/api/types';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePrivateExtensionsList } from '~/swr-hooks/filters/usePrivateExtensionsList';

type PrivateExtensionsSelectProps = {
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateExtensionsSelect = memo(({ boardId, libraryId, ...props }: PrivateExtensionsSelectProps) => {
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePrivateExtensionsList({
    search: debouncedSearchValue,
    boardId,
    libraryId,
  });

  return (
    <StringSelect
      id="extension"
      placeholder="Search for extensions"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PrivateExtensionsSelect.displayName = 'PrivateExtensionsSelect';
